import { Pipe, PipeTransform } from '@angular/core';
import { isset } from '@cawita/core-front';

@Pipe({
  name: 'formatBadgeNumber'
})
export class FormatBadgeNumberPipe implements PipeTransform {

  transform(value: number, maxValue?: number): string {
    return formatBadgeNumber(value, maxValue);
  }
}

export const formatBadgeNumber = (value: number, maxValue = 999): string => {
  if (!isset(value)) { return null; }
  if (value <= maxValue) { return `${value}`; }
  return `${maxValue}+`;
};
